// should depricate these & use SupportedLocales
import Cookies from 'js-cookie';
import { COOKIE_USER_LOCALE } from '@/constants';

export const EN_US = 'en-US';
export const FR_CA = 'fr-CA';
export const JA_JP = 'ja-JP';
export const KO_KR = 'ko-KR';
export const ZH_CN = 'zh-CN';

export enum SupportedLocales {
    EN_US = 'en-US',
    FR_CA = 'fr-CA',
    JA_JP = 'ja-JP',
    KO_KR = 'ko-KR',
    ZH_CN = 'zh-CN',
}

/*
 *
 * The first language specified
 * in this list will be used as THE
 * default locale throughout the
 * application
 *
 */
export const supportedLocales = [
    SupportedLocales.EN_US,
    SupportedLocales.FR_CA,
    SupportedLocales.JA_JP,
    SupportedLocales.KO_KR,
    SupportedLocales.ZH_CN,
];

export const supportedLanguages = supportedLocales.map((l) => l.split('-')[0]);

export type SupportedLocale = (typeof supportedLocales)[number];
export type SupportedLanguages = (typeof supportedLanguages)[number];

export function pathHasLang(path: string) {
    const languages = new Set(supportedLanguages);
    return path.split('/').reduce((acc, cur) => acc || languages.has(cur), false);
}

type Location = {
    pathname?: string;
    search?: string;
    hash?: string;
};
export function addLanguageSlug(location: string | Location, lang?: SupportedLanguages) {
    const language = lang || Cookies.get(COOKIE_USER_LOCALE);
    const regex = /\/\/+/g;

    if (typeof location === 'string') {
        const cleanUrl = location.replace(regex, '/');
        return pathHasLang(cleanUrl) ? cleanUrl : `/${language}${cleanUrl}`;
    }

    const { pathname, search, hash = '' } = location;
    const cleanPathname = pathname?.replace(regex, '/')!;

    const fixedPathname = pathHasLang(cleanPathname)
        ? cleanPathname
        : `/${language}${cleanPathname}`;
    const fixedSearch = Array.from(`${search}`)[0] === '?' || search === '' ? search : `?${search}`;
    const fixedHash = Array.from(`${hash}`)[0] === '#' || hash === '' ? hash : `#${hash}`;

    return `${fixedPathname}${fixedSearch}${fixedHash}`;
}
